<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <a-card title="Listar Departamentos">
    <div class="row" style="margin-bottom: 1%">
      <div class="col-md-9">
        <label for="nome">Departamento</label>
        <div class="input-group input-focus">
          <input type="text" class="form-control form-input-component" v-model="nome" ref="nome" />
        </div>
      </div>
      <div class="col-md-3">
        <label for="cpf">Status</label>

        <div class="input-group input-focus">
          <select v-model="situacao" class="form-select form-input-component">
            <option value="TODOS">Todos</option>
            <option value="ATIVO">Ativo</option>
            <option value="INATIVO">Inativo</option>
          </select>
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-4" style="margin-bottom: 0.3%">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" class="btn btn-primary" @click="criarNova" style="margin: 0 5px"><i class="fa fa-plus"> </i> Criar novo</button>
      </div>
    </div>
  </a-card>
  <br />
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #situacao="{ record }">
        <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacao(record)" />
      </template>
      <template #prazo="{ record }">
        {{ record.prazo + ' meses' }}
      </template>
      <template #action="{ record }">
        <a @click="visualizarDepartamento(record)">
          <i class="fas fa-eye icon-trash"></i>
        </a>
        &nbsp;&nbsp;
        <a title="Excluir" @click="excluirDepartamento(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editarDepartamento(record)"><i class="fas fa-edit icon-edit"></i></a>
      </template>
    </a-table>
  </a-card>
  <Dialog
    header="Detalhes do Departamento"
    v-model:visible="showDialog"
    style="
       {
        backgroundcolor: #dcdeff;
      }
    "
    id="showDialog"
  >
    <div class="row">
      <div><label style="margin-left: 1px; font-weight: bold">Departamento: </label> {{ this.departamentoSelecionado.departamento }}</div>
      <div><label style="margin-left: 1px; font-weight: bold">Status: </label> {{ this.departamentoSelecionado.situacao }}</div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div>
        <a-table :dataSource="departamentoSelecionado.especialidades" :columns="columnsTableEspecialidade" :key="this.departamentoSelecionado.id">
          <template #situacao="{ record }">
            <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacaoDepartamentoEspecialidade(record)" />
          </template>
        </a-table>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteDepartamentoById, getListaDepartamento, createDepartamento } from '@/components/service/departamentoService';

export default {
  name: 'PageListarDepartamento',
  data() {
    return {
      situacao: 'TODOS',
      nome: undefined,
      departamentoSelecionado: undefined,
      lista: [],
      showDialog: false,
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Departamento',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },

        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      columnsTableEspecialidade: [
        {
          title: 'Especialidade',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
      ],
    };
  },
  methods: {
    excluirDepartamento(record) {
      deleteDepartamentoById(record.id)
        .then(() => {
          openNotification(typesNotification.success, 'Departamento excluído com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir Departamento!');
        });
    },
    editarDepartamento(record) {
      this.$router.push({ path: '/form-departamento', query: { id: record.id } });
    },
    visualizarDepartamento(record) {
      this.departamentoSelecionado = record;
      this.showDialog = true;
    },
    criarNova() {
      this.$router.push('form-departamento');
    },
    async toggleSituacao(alimento) {
      const novoStatus = alimento.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      const novoAlimento = { ...alimento, situacao: novoStatus };
      await createDepartamento(novoAlimento);
      this.lista.find((i) => i.id == alimento.id).situacao = novoStatus;
      openNotification(typesNotification.success, 'Status do departamento alterado com sucesso!');
    },

    async toggleSituacaoDepartamentoEspecialidade(especialidade) {
      const novoStatus = especialidade.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      this.departamentoSelecionado.especialidades.find((i) => i.id == especialidade.id).situacao = novoStatus;
      await createDepartamento(this.departamentoSelecionado);
      openNotification(typesNotification.success, 'Status da especialidade alterado com sucesso!');
    },
    async pesquisar() {
      var filtros = { nome: this.nome, situacao: this.situacao };
      getListaDepartamento(filtros)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de departamentos cadastrados!');
        });
    },
  },
  created() {
    this.pesquisar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
